import { render, staticRenderFns } from "./QueueInfo.vue?vue&type=template&id=c61568fa"
import script from "./QueueInfo.vue?vue&type=script&lang=js"
export * from "./QueueInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports